<template>
    <div class="mention">
        <span
            class="legend"
            :style="{ color: color }"
        >
            {{ message }}
        </span>
    </div>
</template>

<script>
    export default {
        name: 'Mention',
        props: {
            message: {
                type: String,
                default: false,
            },
            color: {
                type: String,
                default: 'black'
            }
        }
    }
</script>

<style lang="scss" scoped>
    .mention {
        position: fixed;
        font-style: italic;
        bottom: 5px;
        left: 2em;
        z-index: 1;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        width: 100%;
        pointer-events: none;
    }

    .openedSidebar {
        .mention {
            margin-left: 340px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Mention.vue